import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { CreateAccount } from '@webapp/store/auth/action-creators';
import {
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_ERROR,
} from '@webapp/store/auth/actions';

import BasicAccountData from '@webapp/types/auth/basic-account-data';

import EmailPasswordCtrl from '@webapp/controllers/registration/email-password';

interface CreateAccountCtrlProps {
  createAccount: (data: BasicAccountData) => CreateAccount;
  className?: string;
  isLoading: boolean;
  hasInfo?: boolean;
  setHasInfo?: React.Dispatch<React.SetStateAction<boolean>>;
  setContactValue?: (email: string) => void;
}

const mapStateToProps = (state: AppState) => ({
  isLoading: !!state.ui.loading[CREATE_ACCOUNT],
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createAccount: (data: BasicAccountData) => dispatch(new CreateAccount(data)),
});

export const CreateAccountCtrl: React.FC<CreateAccountCtrlProps> = (props) => {
  return (
    <div className="mb-20">
      <EmailPasswordCtrl
        screen="registration"
        onSubmit={(data) => props.createAccount(data)}
        action={
          !!props.isLoading ? (
            <Translate id="REGISTER.BUTTON.REGISTERING" />
          ) : (
            <Translate id="REGISTER.BUTTON.REGISTER" />
          )
        }
        errorKey={CREATE_ACCOUNT_ERROR}
        isLoading={props.isLoading}
        includeName
        hasInfo={props.hasInfo}
        setHasInfo={props.setHasInfo}
        setContactValue={props.setContactValue}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccountCtrl);
